import type { ComponentProps } from "react";

import { Subline } from "@/components/typography/Subline";
import { Headline } from "@/components/typography/Headline";
import type { HeadlineSize } from "@/components/typography/Headline";
import { cn } from "@/lib/utils";

type SectionSize = HeadlineSize;

type SectionHeaderProps = {
  tagline: string;
  headline: string;
  size?: SectionSize;
  center?: boolean;
} & ComponentProps<"header">;

const SectionHeader = ({
  tagline,
  headline,
  size = "tall",
  center = false,
  ...rest
}: SectionHeaderProps) => (
  <header className={cn("mb-8", { "text-center": center }, rest.className)}>
    <Subline size="tall">{tagline}</Subline>
    <Headline
      as="h2"
      size={size}
      className={cn("max-w-4xl", { "max-w-none": center })}
    >
      {headline}
    </Headline>
  </header>
);

export { SectionHeader };
export type { SectionSize };
